import { Country, GeographicDistribution, ReportItem, Sector, SectorDistribution, Split, StageDistribution } from "./Common";

export enum PortfolioStatus{
    Draft, Pending, Live, Closed
}
export enum PortfolioTimeline{
    ThreeMonth, SixMonth, OneYear, TwoYears
}
export enum InvestorSex{
    Male, Female, Neutral
}

export enum ReportType{
    Announcement, QuarterlyReport, DataRoom
}

export interface PortfolioSectorDistribution extends SectorDistribution{}

export interface PortfolioStageDistribution extends StageDistribution{}

export interface PortfolioGeographicDistribution extends GeographicDistribution{}

export interface PortfolioFundAllocation{
    id: number;
    name : string;
    amount: number;
    logo: string;
}

export interface PortfolioLibraryItem{
    id: string;
    status: PortfolioStatus;
    name: string;
    fundraisingTarget: number;
    raisedAmount: number;
    closingDate: Date;
    moic: number;
    dpi: number;
    irr?: number;
    tvpi?: number;
    managementFee?: number;
    carryFee?: number;
    sectorDistribution: PortfolioSectorDistribution[];
    stageDistribution: PortfolioStageDistribution;
    geographicDistribution: PortfolioGeographicDistribution[];
    fundAllocation: PortfolioFundAllocation[];
    isEltif: boolean;
    isCompliant: boolean;
}

export interface PortfolioLibraryCount{
    status: PortfolioStatus;
    count: number;
}

export interface PortfolioDetailsFundItem{
    id: number;
    name: string;
    proportion: number;
    dpi: number;
    moic: number;
    tvpi: number;
    capitalCalled: number;
    netWorthValue: number;
    sectors: PortfolioDetailsFundSector[];
    reports: PortfolioDetailsFundReportItem[]
}

export interface PortfolioDetailsFundReportItem{
    id: number;
    name: string;
    date: Date;
    url : string;
}

export interface PortfolioDetailsFundSector{
    id: number;
    name: string;
    proportion: number;
    icon: string;
}

export interface PortfolioDetailsReportItem extends ReportItem{
    type: ReportType;
}
export interface PortfolioDetailsInvestorItem{
    id: number;
    name: string;
    surname: string;
    age: number;
    sex: InvestorSex;
    amount: number;
    email: string;
    phone: string;
    city: string;
    country: string;
    split: string;
}
export interface PortfolioDetailsInvestmentTicketItem{
    id: number;
    amount: number;
}

export interface PortfolioDetailsItem{
    id: string;
    status: PortfolioStatus;
    name: string;
    fundraisingTarget: number;
    raisedAmount: number;
    raisedAmountInTime: number[];
    funds: PortfolioDetailsFundItem[];
    moic: number;
    revenueManagment: number;
    dpi: number;
    irr: number;
    carryFee: number;
    tvpi: number;
    closingDate: Date;
    splits: PortfolioGeographicDistribution[];
    sectors: PortfolioSectorDistribution[];
    stages: PortfolioStageDistribution;
    investors: PortfolioDetailsInvestorItem[];
    reports: PortfolioDetailsReportItem[];
    tickets: PortfolioDetailsInvestmentTicketItem[];
}

/* CREATE // EDIT */

export enum PortfolioAffectation {
    Manual, Ai
}
export enum PortfolioIncorporation{
    Customer, Leo
}
export interface SectorAffectation extends Sector{
    proportion: number;
}

export interface SplitAffectation extends Split{
    proportion: number;
}

export interface CountryAffectation extends Country{
    proportion: number;
}

export interface FundAffectation{
    id: number;
    proportion: number;
}

export interface PortfolioCreateItem{
    id?: string;
    name?: string;
    fundraisingTarget: number;
    fundCount: number;
    stage: StageDistribution;
    splits: SplitAffectation[];
    countries: CountryAffectation[];
    sectors: SectorAffectation[];
    funds: FundAffectation[];
    managementFees?: number;
    carryFees?: number;
    portfolioLife?: string;
    multipleAtExit?: number;
    affectationType?: PortfolioAffectation;
    incorporationType?: PortfolioIncorporation;
    step: number;
    accreditedInvestors: boolean;
    retailInvestors: boolean;
}

export enum PortfolioTrackEventType{
    Submit, Lawyers, MissingDocument, Completed
}
export interface PortfolioTrackingEvent{
    id: number;
    type: PortfolioTrackEventType;
    eventTime: Date;
}

export interface PortfolioTracking{
    id: string;
    name: string;
    size: number;
    events: PortfolioTrackingEvent[];
}